const brandColors = {
    Primary_Red_120: '#BA264D',
    Primary_Red_100: '#FE1251',
    Primary_Red_75: '#FE4D7C',
    Primary_Red_50: '#FE88A8',
    Primary_Red_25: '#FFC4D3',
    Primary_Red_7: '#FFEEF3',
    Primary_Red_7D: '#5F2836',
    Primary_Blue_120: '#64B0BF',
    Primary_Blue_100: '#59DEF3',
    Primary_Blue_75: '#82E6F6',
    Primary_Blue_50: '#ACEEF9',
    Primary_Blue_25: '#E3F7FC',
    Primary_Blue_7: '#F3FDFE',
    Primary_Blue_140: '#358592',
    Primary_Blue_160: '#245961',
    Primary_Green_120: '#54A494',
    Primary_Green_100: '#3ACFB9',
    Primary_Green_75: '#6BDBCA',
    Primary_Green_50: '#9CE7DC',
    Primary_Green_25: '#CEF3ED',
    Primary_Green_7: '#EBFAF8',
    Primary_Green_140: '#1D685D',
    Primary_Green_160: '#29524A',
};
var brandColors$1 = brandColors;

export { brandColors$1 as default };
